<!-- start leftbar -->
<div class="left-menu" id="leftmenu">
    <!---start app-name-txt-->
    <div class="module-name">
        <ng-container *ngIf="selectedModule?.type !== 'notification-center' && selectedModule?.type !== 'create-app'">
            <div class="app-name user-name">
                <span>{{userData?.displayName[0] | uppercase}}</span>
            </div>
            <h2 class="name">{{selectedModule?.type==='profile'? 'Profile & Settings' : 'My Vahana'}}</h2>
        </ng-container>


        <ng-container
            *ngIf="selectedModule?.type==='workspace' || selectedModule?.type==='home' || selectedModule?.type==='profile' || selectedModule?.type==='notification-center' || selectedModule?.type=='applications' || selectedModule?.type=='create-app' ;else imageTemp">
            <ng-container *ngIf="selectedModule?.type==='notification-center'">
                    <span class="user-name"><span>NC</span></span>
                    <h2 class="name">Notification Center</h2>
            </ng-container>


            <ng-container *ngIf="selectedModule?.type === 'create-app'">
                    <div class="app-name icon-box icon-va-app-setting"></div>
                    <h2 class="name">App Creation</h2>
            </ng-container>
        </ng-container>

        <ng-template #imageTemp>
            <a href="javascript:void(0)" class="icon-box" aria-label="blank">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24"
                    height="25" viewBox="0 0 24 25">
                    <defs>
                        <path id="uc5x288y8a"
                            d="M16.137 7.06l.303 1.503c.403.151.766.363 1.089.635l1.462-.494L20 10.449l-1.15 1.018c.03.212.06.414.06.636 0 .222-.03.423-.06.635L20 13.757l-1.009 1.745-1.462-.494c-.323.272-.686.484-1.09.635l-.302 1.503H14.12l-.303-1.503c-.403-.151-.766-.363-1.089-.635l-1.462.494-1.009-1.745 1.15-1.019c-.03-.212-.06-.413-.06-.635 0-.222.03-.424.06-.636l-1.15-1.018 1.009-1.745 1.462.494c.323-.272.686-.484 1.09-.635l.302-1.503h2.017zM8.07 9.077c.232 0 .453.01.675.02-.423.918-.675 1.927-.675 3.006 0 1.503.474 2.894 1.27 4.034H0v-2.673c0-1.038.514-2.027 1.402-2.551 1.946-1.16 4.226-1.836 6.667-1.836zm7.06 1.009c-1.11 0-2.018.907-2.018 2.017 0 1.11.908 2.017 2.018 2.017 1.109 0 2.017-.908 2.017-2.017 0-1.11-.908-2.017-2.017-2.017zM8.069 0c2.228 0 4.034 1.806 4.034 4.034 0 2.228-1.806 4.035-4.034 4.035-2.228 0-4.035-1.807-4.035-4.035S5.841 0 8.07 0z" />
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                        <g>
                            <g>
                                <g>
                                    <g
                                        transform="translate(-558 -129) translate(542 118) translate(16 12) translate(2 3)">
                                        <mask id="qkoegxbg2b" fill="#fff">
                                            <use xlink:href="#uc5x288y8a" />
                                        </mask>
                                        <path fill="#FFF" d="M-2 -3H22V21H-2z" mask="url(#qkoegxbg2b)" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </a>
        </ng-template>
    </div>
    <!--end app-name-txt-->

    <!--start with scrollbar mid-menu-->
    <div class="sub-module">
        <perfect-scrollbar>
            <ul>
                <li class="tooltip-link" *ngIf="selectedModule?.type=='home' || selectedModule?.type=='applications'">
                    <a href="javascript:void(0)" aria-label="blank" [routerLink]="['/home']"
                        [routerLinkActive]="['active']">
                        <span class="icon-box icon-va-home"></span>
                        <span class="name">Vahana Home</span>
                    </a>
                </li>

                <li class="tooltip-link"
                    *ngIf="selectedModule?.type=='home'|| selectedModule?.type=='applications' || selectedModule?.type === 'create-app'">
                    <a href="javascript:void(0)" aria-label="blank"
                        [ngClass]="selectedModule?.type === 'create-app' || selectedModule?.type=='applications'?'active':''"
                        [routerLink]="['/app-management/applications']">
                        <span class="icon-box icon-va-applications"></span>
                        <span class="name">Applications</span>
                    </a>
                </li>

                <li class="tooltip-link" *ngIf="selectedModule?.type=='notification-center'"
                    [routerLink]="['/notification-center']" [routerLinkActive]="['active']">
                    <a href="javascript:void(0)" aria-label="blank" class="active">
                        <span class="icon-box icon-va-notification-center"></span>
                        <span class="name">Notification Center</span>
                    </a>
                </li>

                <li class="tooltip-link" *ngIf="selectedModule?.type=='workspace'" [routerLink]="['/workspace']">
                    <a href="javascript:void(0)" aria-label="blank" [routerLinkActive]="['active']">
                        <span class="icon-box icon-va-workspace"></span>
                        <span class="name">My Workspaces</span>
                    </a>
                </li>

                <li class="tooltip-link" *ngIf="selectedModule?.type=='profile'" [routerLink]="['/profile']">
                    <a href="javascript:void(0)" aria-label="blank" [routerLinkActive]="['active']">
                        <span class="icon-box icon-va-profile"></span>
                        <span class="name">Profile</span>
                    </a>
                </li>
            </ul>
        </perfect-scrollbar>
    </div>
    <!--end with scrollbar mid-menu-->

    <!--start external-links-->
    <div class="external-links">
        <ul>
            <li>
                <a href="javascript:void(0)" aria-label="blank" (click)="openvAcademy()">
                    <span class="icon-box icon-va-school"></span>
                    <span class="name">Vahana Academy</span>
                </a>
            </li>

            <li>
                <a href="javascript:void(0)" aria-label="blank" (click)="goToCommunity()">
                    <span class="icon-box icon-va-chat"></span>
                    <span class="name">Vahana Community</span>
                </a>
            </li>

            <li>
                <a href="javascript:void(0)" aria-label="blank" (click)="callsslTokenApi()">
                    <span class="icon-box icon-va-help"></span>
                    <span class="name">Support Portal</span>
                </a>
            </li>
        </ul>
    </div>
    <!--end community-->

    <!-- start expand -->
    <!-- <div class="expand tooltip-link" fxLayoutAlign="end center">
        <a href="#!" aria-label="blank" (click)='expandLeftMenu()' fxLayoutAlign="center center">
            <span class="icon icon-va-last-page open"></span>
            <span class="icon icon-va-first-page close"></span>
            <span id='expTool' class="tooltip-bx">Expand</span>
        </a>
    </div> -->
    <!-- end expand -->
</div>

<!-- end leftbar-->